import { createAsyncThunk } from '@reduxjs/toolkit'
import PendingBranding from './pending-branding-model'
import {
  delete_pendingBranding,
  load_pendingBrandings,
  store_pendingBranding,
} from './pendingBranding-service'

export const LoadPendingBrandingsAsync = createAsyncThunk<any, any>(
  'composer/load/pendingBranding',
  async (params: { uid: string }) => {
    return await load_pendingBrandings(params)
  },
)

export const CreatePendingBrandingAsync = createAsyncThunk<any, any>(
  'composer/create/pendingBranding',
  async (params: PendingBranding) => {
    return await store_pendingBranding(params)
  },
)

export const DeletePendingBrandingAsync = createAsyncThunk<any, any>(
  'composer/delete/pendingBranding',
  async (params) => {
    return await delete_pendingBranding(params)
  },
)
